/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <div class="profile-view-container">

    <div class="section-header-row">
      <h2 class="section-subtitle">Información del Perfil</h2>
    </div>

    <div class="dashboard-card view-card">
      <div class="card-body">

        <div class="inputs-grid">

          <div class="form-group">
            <label for="nombre">Nombre*</label>
            <div class="input-wrapper">
              <i class="fa-solid fa-user input-icon"></i>
              <input type="text" id="nombre" class="clean-input" :value="localData.nombre"
                @input="updateLocalField('nombre', $event.target.value)" :readonly="!isEditing" placeholder="Tu nombre">
            </div>
            <small v-if="isEditing && !localData.nombre" class="error-msg">El nombre es obligatorio</small>
          </div>

          <div class="form-group">
            <label for="apellidoPaterno">Apellido Paterno*</label>
            <div class="input-wrapper">
              <input type="text" id="apellidoPaterno" class="clean-input no-icon" :value="localData.apellido_paterno"
                @input="updateLocalField('apellido_paterno', $event.target.value)" :readonly="!isEditing">
            </div>
            <small v-if="isEditing && !localData.apellido_paterno" class="error-msg">Campo obligatorio</small>
          </div>

          <div class="form-group">
            <label for="apellidoMaterno">Apellido Materno*</label>
            <div class="input-wrapper">
              <input type="text" id="apellidoMaterno" class="clean-input no-icon" :value="localData.apellido_materno"
                @input="updateLocalField('apellido_materno', $event.target.value)" :readonly="!isEditing">
            </div>
            <small v-if="isEditing && !localData.apellido_materno" class="error-msg">Campo obligatorio</small>
          </div>

          <div class="form-group">
            <label for="correo">Correo Electrónico*</label>
            <div class="input-wrapper">
              <i class="fa-solid fa-envelope input-icon"></i>
              <input type="email" id="correo" class="clean-input" :value="localData.correo"
                @input="updateLocalField('correo', $event.target.value)" :readonly="!isEditing">
            </div>
            <small v-if="isEditing && !localData.correo" class="error-msg">El correo es obligatorio</small>
          </div>

          <div class="form-group">
            <label for="telefono">Teléfono*</label>
            <div class="input-wrapper">
              <i class="fa-solid fa-phone input-icon"></i>
              <input type="tel" id="telefono" class="clean-input" :value="localData.telefono" @input="handlePhoneInput"
                :readonly="!isEditing" placeholder="+52 (000) 000 0000">
            </div>
            <small v-if="isEditing && (!localData.telefono || localData.telefono.length < 17)" class="error-msg">
              Teléfono incompleto
            </small>
          </div>

          <div class="form-group">
            <label for="rol">Rol</label>
            <div class="input-wrapper">
              <i class="fa-solid fa-id-badge input-icon"></i>
              <input type="text" id="rol" class="clean-input locked-input" :value="FormatoRol(usuario.rol)" readonly>
            </div>
          </div>

          <div class="form-group span-3">
            <label for="domicilio">Domicilio*</label>
            <div class="input-wrapper">
              <i class="fa-solid fa-map-pin input-icon"></i>
              <input type="text" id="domicilio" class="clean-input" :value="localData.domicilio"
                @input="updateLocalField('domicilio', $event.target.value)" :readonly="!isEditing"
                placeholder="Calle, número y colonia">
            </div>
            <small v-if="isEditing && !localData.domicilio" class="error-msg">El domicilio es obligatorio</small>
          </div>

          <div class="form-group">
            <label for="estado">Estado*</label>
            <div class="input-wrapper">
              <input v-if="!isEditing" type="text" class="clean-input no-icon" :value="localData.estado" readonly>

              <select v-else :value="localData.estado" @change="onCambioEstado($event.target.value)"
                class="clean-input no-icon">
                <option value="" disabled>-- Selecciona --</option>
                <option v-for="estadoObj in estadosData.estados" :key="estadoObj.nombre" :value="estadoObj.nombre">
                  {{ estadoObj.nombre }}
                </option>
              </select>
            </div>
            <small v-if="isEditing && !localData.estado" class="error-msg">Selecciona un estado</small>
          </div>

          <div class="form-group">
            <label for="ciudad">Ciudad*</label>
            <div class="input-wrapper">
              <input v-if="!isEditing" type="text" class="clean-input no-icon" :value="localData.ciudad" readonly>

              <select v-else :value="localData.ciudad" @change="updateLocalField('ciudad', $event.target.value)"
                class="clean-input no-icon" :disabled="!localData.estado">
                <option value="" disabled>-- Selecciona --</option>
                <option v-for="municipio in municipiosDisponibles" :key="municipio" :value="municipio">
                  {{ municipio }}
                </option>
              </select>
            </div>
            <small v-if="isEditing && localData.estado && !localData.ciudad" class="error-msg">
              Selecciona una ciudad
            </small>
          </div>

          <div class="form-group">
            <label for="pais">País</label>
            <div class="input-wrapper">
              <i class="fa-solid fa-globe input-icon"></i>
              <input type="text" id="pais" class="clean-input locked-input" :value="localData.pais"
                @input="updateLocalField('pais', $event.target.value)" readonly>
            </div>
          </div>

        </div>

        <div class="buttons-row">
          <template v-if="!isEditing">
            <router-link to="/Bienvenida" class="link-back">
              <Button class="btn-secondary-action">Regresar</Button>
            </router-link>
            <Button class="btn-primary-action btn-edit" @click="isEditing = true">Editar Datos</Button>
          </template>

          <template v-else>
            <Button class="btn-secondary-action" @click="cancelEdit">Cancelar</Button>
            <Button class="btn-primary-action" @click="saveChanges" :disabled="mostrarLoader || !formularioValido">
              {{ mostrarLoader ? 'Guardando...' : 'Guardar Cambios' }}
            </Button>
          </template>
        </div>

      </div>
    </div>

    <ModalExito :mostrarExito="mostrarExito" mensajeExito="¡Datos actualizados correctamente!" />

  </div>
</template>

<script>
import Button from '@/components/Forms/Button.vue';
import userService from '@/services/userService';
import dataEstadosMunicipios from '@/data/estados_municipios.json';
import ModalExito from "../Modales/ModalExito.vue";

export default {
  components: {
    Button,
    ModalExito
  },
  props: {
    usuario: {
      type: Object,
      required: true,
      default: () => ({
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        correo: '',
        rol: '',
        telefono: '',
        domicilio: '',
        estado: '',
        ciudad: '',
        pais: '',
      })
    },
    rolOpciones: { type: Object, required: true },
    FormatoRol: { type: Function, required: true }
  },
  data() {
    return {
      isEditing: false,
      mostrarExito: false,
      mostrarLoader: false,
      estadosData: dataEstadosMunicipios,
      localData: {
        ...this.usuario
      }
    };
  },
  computed: {
    municipiosDisponibles() {
      if (!this.localData.estado) return [];
      const estadoEncontrado = this.estadosData.estados.find(
        e => e.nombre === this.localData.estado
      );
      return estadoEncontrado ? estadoEncontrado.municipios.map(m => m.nombre) : [];
    },
    formularioValido() {
      return (
        this.localData.nombre &&
        this.localData.apellido_paterno &&
        this.localData.apellido_materno &&
        this.localData.correo &&
        this.localData.telefono &&
        this.localData.telefono.length >= 17 &&
        this.localData.domicilio &&
        this.localData.estado &&
        this.localData.ciudad
      );
    }
  },
  watch: {
    usuario: {
      handler(newVal) {
        this.localData = { ...newVal };
        if (this.localData.telefono) {
          this.localData.telefono = this.formatPhoneNumber(this.localData.telefono);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    updateLocalField(field, value) {
      this.localData[field] = value;
    },

    formatPhoneNumber(value) {
      if (!value) return '+52 ';
      let cleaned = value.replace(/\D/g, '');
      if (cleaned.startsWith('52')) cleaned = cleaned.substring(2);
      cleaned = cleaned.substring(0, 10);

      let formatted = '+52 ';
      if (cleaned.length > 0) formatted += '(' + cleaned.substring(0, 3);
      if (cleaned.length >= 4) formatted += ') ' + cleaned.substring(3, 6);
      if (cleaned.length >= 7) formatted += ' ' + cleaned.substring(6, 10);
      return formatted;
    },

    handlePhoneInput(event) {
      const formatted = this.formatPhoneNumber(event.target.value);
      this.localData.telefono = formatted;
    },

    onCambioEstado(nuevoEstado) {
      this.localData.estado = nuevoEstado;
      this.localData.ciudad = '';
    },

    async saveChanges() {
      this.mostrarLoader = true;
      const payload = {
        nombre: this.localData.nombre,
        ape_pat: this.localData.apellido_paterno,
        ape_mat: this.localData.apellido_materno,
        correo: this.localData.correo,
        telefono: this.localData.telefono.replace(/\D/g, ''),
        domicilio: this.localData.domicilio,
        estado: this.localData.estado,
        ciudad: this.localData.ciudad,
        pais: this.localData.pais,
      };

      try {
        const response = await userService.updateUser(this.usuario.id, payload);
        const usuarioData = response.data;
        localStorage.setItem('userData', JSON.stringify(usuarioData));
        this.$emit('datos-actualizados', usuarioData);

        this.mostrarExito = true;
        this.isEditing = false;

        setTimeout(() => {
          this.mostrarExito = false;
          window.location.reload();
        }, 1500);

      } catch (error) {
        console.error("Error en actualización:", error);
        alert('Error al actualizar los datos');
      } finally {
        this.mostrarLoader = false;
      }
    },

    cancelEdit() {
      this.localData = { ...this.usuario };
      if (this.localData.telefono) {
        this.localData.telefono = this.formatPhoneNumber(this.localData.telefono);
      }
      this.isEditing = false;
    }
  },
};
</script>

<style scoped>
.profile-view-container {
  --mc-primary: #4652e8;
  --mc-border: #e2e8f0;
  --mc-text-main: #1e293b;
  --mc-text-muted: #64748b;
  --mc-bg-input: #f8fafc;
  --mc-bg-card: #ffffff;
  width: 100%;
  box-sizing: border-box;
  color: var(--mc-text-main);
}
.error-msg {
  color: #dc3545;
  font-size: 11px;
  margin-top: 4px;
  font-weight: 500;
}

.profile-view-container * {
  box-sizing: border-box;
  text-decoration: none;
}

.section-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-subtitle {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.dashboard-card {
  background: var(--mc-bg-card);
  border: 1px solid var(--mc-border);
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-body {
  padding: 30px;
}

.inputs-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  margin-bottom: 30px;
}

.span-3 {
  grid-column: span 3;
}

.form-group {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: var(--mc-text-main);
  margin-bottom: 8px;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 0.9rem;
  pointer-events: none;
}

.clean-input {
  width: 100%;
  height: 42px;
  padding: 0 12px 0 40px;
  border: 1px solid var(--mc-border);
  border-radius: 8px;
  font-size: 14px;
  background: #ffffff;
  color: var(--mc-text-main);
  outline: none;
  transition: all 0.2s ease;
}

.clean-input.no-icon {
  padding-left: 15px;
}

.clean-input:focus:not([readonly]) {
  border-color: #29b9f6;
  box-shadow: 0 0 0 3px rgba(47, 141, 183, 0.1);
}

.clean-input[readonly] {
  background-color: #fcfcfc;
  color: #64748b;
  border-color: #e2e8f0;
}

.locked-input {
  background-color: #f1f5f9 !important;
  color: #94a3b8;
  cursor: not-allowed;
}

.buttons-row {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  border-top: 1px solid var(--mc-border);
  padding-top: 25px;
}

.btn-primary-action {
  background-color: #2a428c;
  color: white;
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.btn-primary-action:disabled {
  background-color: #cbd5e1;
  cursor: not-allowed;
  opacity: 0.8;
}

.btn-secondary-action {
  background-color: white;
  color: #64748b;
  border: 1px solid var(--mc-border);
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 900px) {
  .inputs-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .span-3 {
    grid-column: span 1;
  }

  .buttons-row {
    justify-content: space-between;
  }
}
</style>